import React from "react";
import { Box } from "@mui/material";
import Seo from "../components/Seo";

import HomeHero from "../components/home/HomeHero";
import HomeMetrics from "../components/home/HomeMetrics";
import HomeFeatures from "../components/home/HomeFeatures";
import HomeHowItWorks from "../components/home/HomeHowItWorks";
import HomeStatuses from "../components/home/HomeStatuses";
import HomeAudience from "../components/home/HomeAudience";
import HomeBanks from "../components/home/HomeBanks";
import HomePricing from "../components/home/HomePricing";
import HomePrivacy from "../components/home/HomePrivacy";
import HomeFaq from "../components/home/HomeFaq";

function Home() {
    return (
        <Box sx={{ bgcolor: "#f8fafc" }}>
            <Seo
                title="Qarzhy: автоматизированная сверка банковских платежей"
                description="Qarzhy – автоматизированная сверка платежных поручений с бухгалтерским учетом. Сервис для автоматизированной сверки банковских платежных поручений с данными бухгалтерского и кадрового учета, а также конвертации PDF-документов в структурированные Excel-реестры."
                keywords="сверка платежных поручений, сверка с бухгалтерским учетом, сверка банка и учета, сверка платежных поручений с учетом, проверка банковских платежек, банковские платежные поручения, сверка кадровых данных, PDF в Excel, реестр выплат, обработка банковских документов, Qarzhy"
                url="https://qarzhy.kz/"
            />

            <HomeHero />
            <HomeMetrics />
            <HomeFeatures />
            <HomeHowItWorks />
            <HomeStatuses />
            <HomeAudience />
            <HomeBanks />
            <HomePricing />
            <HomePrivacy />
            <HomeFaq />
        </Box>
    );
}

export default Home;